import { MenuItem, Select } from '@mui/material';
import React from 'react';

interface RelationTypeDropdownProps {
  value: 'interval' | 'correlation' | 'difference';
  onChange: (value: 'interval' | 'correlation' | 'difference') => void;
}

export const RelationTypeDropdown: React.FC<RelationTypeDropdownProps> = ({
  value,
  onChange,
}) => {
  return (
    <Select
      value={value}
      onChange={(e) =>
        onChange(e.target.value as 'interval' | 'correlation' | 'difference')
      }
      size="small"
      fullWidth
    >
      <MenuItem value="interval">Intervalle</MenuItem>
      <MenuItem value="correlation">Corrélation</MenuItem>
      <MenuItem value="difference">Différence</MenuItem>
    </Select>
  );
};
